export const INITIAL_BATCH_SIZE = 36;
export const PAGINATION_BATCH_SIZE = 18;
